import { App } from './app'
import { ServerLookup } from './server-lookup'

const app = new App()

document.addEventListener('DOMContentLoaded', () => {
  app.init()

  // Initialize server status lookup
  const serverLookup = new ServerLookup()

  // Navbar scroll effect
  const navbar = document.getElementById('navbar')
  window.addEventListener('scroll', () => {
    if (window.scrollY > 10) {
      navbar.classList.add('scrolled')
    } else {
      navbar.classList.remove('scrolled')
    }
  }, false)

  // Server search
  const searchInput = document.getElementById('server-search')
  if (searchInput) {
    searchInput.addEventListener('input', () => {
      const query = searchInput.value.toLowerCase().trim()
      for (const serverRegistration of app.serverRegistry.getServerRegistrations()) {
        const el = document.getElementById(`container_${serverRegistration.serverId}`)
        if (!el) continue
        if (query === '') {
          el.style.display = ''
        } else {
          const name = (serverRegistration.data.name || '').toLowerCase()
          const ip = (serverRegistration.data.ip || '').toLowerCase()
          el.style.display = (name.includes(query) || ip.includes(query)) ? '' : 'none'
        }
      }
    })
  }

  // Global Stats toggle
  const globalStatsToggle = document.getElementById('global-stats-toggle')
  if (globalStatsToggle) {
    globalStatsToggle.addEventListener('click', () => {
      const panel = document.getElementById('global-stats-panel')
      if (panel.style.display === 'none') {
        panel.style.display = 'block'
        app.updateGlobalPanelStats()
      } else {
        panel.style.display = 'none'
      }
    })
  }

  window.addEventListener('resize', function () {
    app.percentageBar.redraw()

    // Delegate to GraphDisplayManager which can check if the resize is necessary
    app.graphDisplayManager.requestResize()
  }, false)
}, false)
